export default __webpack_public_path__ + "images/logoOgee.ede860b6d360ad8381087da390cb80d9.svg"